import themes from "devextreme/ui/themes";
import { useStoreUser } from "@/stores/userStore";

export const devExtremeThemes = [
  { label: "Generic Light White", value: "generic.light.white", modal: "generic-light-white-modal", lsb: "light-white-theme" },
  { label: "Generic Light", value: "generic.light", modal: "generic-light-modal", lsb: "white-theme" },
  { label: "Generic Dark", value: "generic.dark", modal: "generic-dark-modal", lsb: "dark" },
  { label: "Generic Light Blue", value: "generic.light.blue", modal: "generic-light-blue-modal", lsb: "light-blue-theme" },
  { label: "Generic Dark Blue", value: "generic.dark.blue", modal: "generic-dark-blue-modal", lsb: "blue-theme" },
  { label: "Generic Light Green", value: "generic.light.green", modal: "generic-light-green-modal", lsb: "light-green-theme" },
  { label: "Generic Dark Green", value: "generic.dark.green", modal: "generic-dark-green-modal", lsb: "green-theme" },
{ label: "Generic Light Orange", value: "generic.light.orange", modal: "generic-light-orange-modal", lsb: "light-orange-theme" },
  { label: "Generic Dark Orange", value: "generic.dark.orange", modal: "generic-dark-orange-modal", lsb: "orange-theme" },
  { label: "Generic Light Yellow", value: "generic.light.yellow", modal: "generic-light-yellow-modal", lsb: "light-yellow-theme" },
  { label: "Generic Dark Yellow", value: "generic.dark.yellow", modal: "generic-dark-yellow-modal", lsb: "yellow-theme" },
  { label: "Generic Light Red", value: "generic.light.red", modal: "generic-light-red-modal", lsb: "light-red-theme" },
  { label: "Generic Dark Red", value: "generic.dark.red", modal: "generic-dark-red-modal", lsb: "red-theme" },
];

export function initializeTheme() {
  const userStore = useStoreUser();

  // Load the theme from localStorage, fallback to generic.light if not found
  const themeName = window.localStorage.getItem("dx-theme") || "generic.light.white";
  // console.log("Initializing theme from localStorage:", themeName);
  themes.current("generic.light.white");

  // Find the theme object from devExtremeThemes
  const found = devExtremeThemes.find((t) => t.value === themeName);
  if (found) {
    userStore.bModalTheme = found.modal;
    userStore.lsbTheme = found.lsb;
    userStore.devExTheme = found.value;
    themes.current(found.value);
  } else {
    // fallback to default
    userStore.bModalTheme = devExtremeThemes[0].modal;
    userStore.lsbTheme = devExtremeThemes[0].lsb;
    userStore.devExTheme = devExtremeThemes[0].value;
    themes.current(devExtremeThemes[0].value);
  }

  return found ? found.value : devExtremeThemes[0].value;
}
